import type { ReactNode } from 'react';

interface PanelProps {
  title?: ReactNode;
  /** Right side of the header: pills, badges, buttons. */
  aside?: ReactNode;
  /** Brackets: max two containers per screen, never on repeated cards (rule 11). */
  bracketed?: boolean;
  /** Skip the inner padding (tables, lists). */
  flush?: boolean;
  footer?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function Panel({
  title,
  aside,
  bracketed = false,
  flush = false,
  footer,
  className,
  children,
}: PanelProps) {
  return (
    <section className={['panel', bracketed ? 'tick' : '', className].filter(Boolean).join(' ')}>
      {title === undefined && aside === undefined ? null : (
        <div className="panel-h">
          {typeof title === 'string' ? <h2>{title}</h2> : title}
          {aside === undefined ? null : <span className="rt">{aside}</span>}
        </div>
      )}
      {flush ? children : <div className="panel-b">{children}</div>}
      {footer === undefined ? null : <div className="panel-f">{footer}</div>}
    </section>
  );
}
